import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-teal-50 flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full shadow-2xl">
        <CardHeader className="text-center">
          <CardTitle className="text-3xl font-bold">
            Payment Cancelled
          </CardTitle>
        </CardHeader>
        
        <CardContent className="text-center space-y-6 p-8">
          <XCircle className="w-24 h-24 text-orange-500 mx-auto" />
          
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              Payment Was Cancelled
            </h3>
            <p className="text-gray-600 text-lg">
              You cancelled the payment process. No charges were made.
            </p>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
            <p className="text-blue-800">
              <strong>Your booking is still active!</strong><br />
              You can choose to pay later during pickup/delivery, or you can go back and complete the payment now.
            </p>
          </div>

          <div className="flex gap-4 justify-center">
            <Button
              onClick={() => navigate('/#book-now')}
              className="bg-teal-600 hover:bg-teal-700 text-white"
            >
              Complete Payment
            </Button>
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="border-gray-600 text-gray-600 hover:bg-gray-50"
            >
              Back to Home
            </Button>
          </div>

          <div className="text-sm text-gray-600 space-y-2">
            <p>Need assistance? Contact us:</p>
            <div className="flex justify-center gap-4">
              <a href="tel:762-436-2067" className="text-teal-600 font-semibold hover:underline">
                📞 762-436-2067
              </a>
              <a href="tel:404-424-2452" className="text-teal-600 font-semibold hover:underline">
                📞 404-424-2452
              </a>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
